import styled from 'styled-components';
import Markdown from '../Markdown';

export const BodyMarkdownContent = styled(Markdown)`
  p {
    color: ${({ theme }) => theme.onPrimaryColor};
  }
`;
